import { LANGUAGE_CODES } from '../common/constants/languageCodes';

export const SYSTEM_ERROR_CODES = {
    AUTH_EXPIRED: 'auth-expire',
};

const translations = {
    [LANGUAGE_CODES.ENGLISH]: {
        403: {
            description: 'Sorry, you are not authorized for this action.',
        },
        404: {
            description: 'Sorry, the page or resource you are trying to access does not exist.',
        },
        429: {
            message: 'Too many requests',
            description: 'Sorry, you have exceeded the limit of requests for this action. Try again later.',
        },
        500: {
            message: 'Internal Server Error',
            description: 'Sorry, something went wrong. Please try again later.',
        },
        [SYSTEM_ERROR_CODES.AUTH_EXPIRED]: {
            message: 'Your session has expired.',
            description: 'Proceeding to sign-in',
        },
    },
    [LANGUAGE_CODES.UKRAINIAN]: {
        403: {
            description: 'Вибачте, ви не маєте доступу до цієї дії.',
        },
        404: {
            description: 'Вибачте, сторінка або ресурс, до якого ви намагаєтеся отримати доступ, не існує.',
        },
        429: {
            message: 'Перевищено ліміт запитів',
            description: 'Вибачте, ви перевищили ліміт запитів на дану дію. Будь ласка, спробуйте ще раз пізніше.',
        },
        500: {
            message: 'Помилка сервера',
            description: 'Вибачте, щось пішло не так. Будь ласка, спробуйте ще раз пізніше.',
        },
        [SYSTEM_ERROR_CODES.AUTH_EXPIRED]: {
            message: 'Термін дії вашої сесії закінчився.',
            description: 'Перехід до входу в систему',
        },
    },
    [LANGUAGE_CODES.ITALIAN]: {
        403: {
            description: 'Spiacenti, non sei autorizzato per questa azione.',
        },
        404: {
            description: 'Spiacenti, la pagina o risorsa che stai cercando di accedere non esiste.',
        },
        429: {
            message: 'Troppe richieste',
            description: 'Spiacenti, hai superato il limite di richieste per questa azione. Riprova più tardi.',
        },
        500: {
            message: 'Errore interno del server',
            description: 'Spiacenti, qualcosa è andato storto. Riprova più tardi.',
        },
        [SYSTEM_ERROR_CODES.AUTH_EXPIRED]: {
            message: 'La tua sessione è scaduta.',
            description: 'Procedendo al login',
        },
    },
    [LANGUAGE_CODES.SPANISH]: {
        403: {
            description: 'Lo siento, no estás autorizado para esta acción.',
        },
        404: {
            description: 'Lo siento, la página o recurso al que intentas acceder no existe.',
        },
        429: {
            message: 'Demasiadas solicitudes',
            description:
                'Lo siento, has excedido el límite de solicitudes para esta acción. Inténtalo de nuevo más tarde.',
        },
        500: {
            message: 'Error interno del servidor',
            description: 'Lo siento, algo salió mal. Por favor, inténtalo de nuevo más tarde.',
        },
        [SYSTEM_ERROR_CODES.AUTH_EXPIRED]: {
            message: 'Tu sesión ha expirado.',
            description: 'Procediendo al inicio de sesión',
        },
    },
    [LANGUAGE_CODES.FRENCH]: {
        403: {
            description: "Désolé, vous n'êtes pas autorisé pour cette action.",
        },
        404: {
            description: "Désolé, la page ou la ressource à laquelle vous essayez d'accéder n'existe pas.",
        },
        429: {
            message: 'Trop de requêtes',
            description: 'Désolé, vous avez dépassé la limite de requêtes pour cette action. Réessayez plus tard.',
        },
        500: {
            message: 'Erreur interne du serveur',
            description: "Désolé, quelque chose s'est mal passé. Veuillez réessayer plus tard.",
        },
        [SYSTEM_ERROR_CODES.AUTH_EXPIRED]: {
            message: 'Votre session a expiré.',
            description: 'Procédure de connexion en cours',
        },
    },
    [LANGUAGE_CODES.GERMAN]: {
        403: {
            description: 'Entschuldigung, Sie sind für diese Aktion nicht berechtigt.',
        },
        404: {
            description: 'Entschuldigung, die Seite oder Ressource, auf die Sie zugreifen möchten, existiert nicht.',
        },
        429: {
            message: 'Zu viele Anfragen',
            description:
                'Entschuldigung, Sie haben das Limit für Anfragen für diese Aktion überschritten. Versuchen Sie es später erneut.',
        },
        500: {
            message: 'Interner Serverfehler',
            description: 'Entschuldigung, etwas ist schief gelaufen. Bitte versuchen Sie es später erneut.',
        },
        [SYSTEM_ERROR_CODES.AUTH_EXPIRED]: {
            message: 'Ihre Sitzung ist abgelaufen.',
            description: 'Weiterleitung zur Anmeldung',
        },
    },
};

const getErrorTranslation = (code, lang, field) => {
    const langTranslations = translations[lang] || translations[LANGUAGE_CODES.ENGLISH];

    const codeTranslations = langTranslations[code] || langTranslations[500];

    return codeTranslations?.[field] || 'An error occurred';
};

export default getErrorTranslation;
